import React from "react";
import PropTypes from "prop-types";

import styles from "./PageTitle.module.css";

const PageTitle = ({ data: { text = "" } = {} }) => {
  if (!text) return null;

  return (
    <h1 className={styles.header} id="mainContent">
      {text}
    </h1>
  );
};

export default PageTitle;

PageTitle.propTypes = {
  data: PropTypes.object,
};
